<p class="alert alert-danger">
  Whoops, looks like something went wrong.
  <i class="fa fa-times close-icon" (click)="closeClick.emit()"></i>
</p>
